<script setup lang="ts">
import { gsap } from 'gsap'

const props = defineProps<{
  slug: string
  accent: string
}>()

const localePath = useLocalePath()
const section = ref<HTMLElement | null>(null)

onMounted(() => {
  const el = section.value
  if (!el) return

  gsap.fromTo(el.querySelector('.bt-cta-card'),
    { opacity: 0, y: 40, scale: 0.95 },
    {
      opacity: 1, y: 0, scale: 1, duration: 0.7, ease: 'back.out(1.4)',
      scrollTrigger: { trigger: el, start: 'top 85%', once: true },
    },
  )
})
</script>

<template>
  <section ref="section" class="py-12 md:py-16 lg:py-20 bg-white relative overflow-hidden">
    <div class="absolute inset-0 bg-[radial-gradient(circle,_#d1d5db_1.5px,_transparent_1.5px)] [background-size:28px_28px] opacity-50 pointer-events-none" aria-hidden="true" />
    <div class="container relative">
      <div
        class="bt-cta-card text-center bg-white border-2 border-gray-900 rounded-2xl p-8 md:p-12 max-w-2xl mx-auto"
        :style="{ boxShadow: `10px 10px 0 ${props.accent}` }">
        <h2 class="text-[clamp(1.5rem,3.5vw,2.5rem)] font-bold text-gray-900 mb-3 leading-tight">
          {{ $t(`page.business_types.${props.slug}.cta.title`) }}
        </h2>
        <p class="text-base md:text-lg text-overcast-night mb-7">
          {{ $t(`page.business_types.${props.slug}.cta.sub`) }}
        </p>
        <a v-magnetic :href="localePath('/request-demo')" class="bfm-btn bfm-btn-lg bg-cheese-yellow">
          {{ $t(`page.business_types.${props.slug}.hero.cta`) }}
        </a>
      </div>
    </div>
  </section>
</template>
